module.exports = __webpack_public_path__ + "static/media/map_pin_int.54838e6b.svg";